import { useState } from "react";
import { Lock } from "lucide-react";
import { toast } from "sonner";
import { useDemo } from "@/store/DemoStore";
import { Card, btn } from "@/components/common";
import { fmtMoney, tripCommission, tripTotal } from "@/lib/trip";

export function CommissionCard({ trip }) {
  const { settings, updateTrip } = useDemo();
  const [value, setValue] = useState(String(tripCommission(trip, settings.commissionRate)));
  const amount = Math.max(0, +value || 0);
  const split = settings.agentSplit;
  const agent = Math.round(amount * split) / 100;
  const dirty = amount !== tripCommission(trip, settings.commissionRate);

  return (
    <Card className="border-amber-200/80" data-testid="commission-card">
      <div className="flex items-center justify-between gap-3 px-5 pt-5 sm:px-6">
        <h2 className="text-[11px] font-semibold uppercase tracking-[0.14em] text-slate-400">Commission</h2>
        <span className="inline-flex items-center gap-1 rounded-full bg-amber-50 px-2 py-0.5 text-[10px] font-semibold text-amber-700"><Lock className="h-3 w-3" />Internal only</span>
      </div>
      <div className="space-y-4 p-5 sm:p-6">
        <label className="block">
          <span className="mb-1.5 block text-xs font-medium text-slate-500">Trip commission (USD)</span>
          <div className="flex gap-2">
            <input type="number" min="0" step="0.01" value={value} onChange={(e) => setValue(e.target.value)} data-testid="commission-input" className="h-10 min-w-0 flex-1 rounded-lg border border-slate-200 bg-white px-3 text-base text-navy-900 outline-none focus:border-navy-500 focus:ring-2 focus:ring-navy-100 sm:text-sm" />
            <button disabled={!dirty} onClick={() => { updateTrip(trip.id, { commission: amount }); toast.success("Commission saved"); }} data-testid="commission-save-btn" className={`${btn.primary} h-10`}>Save</button>
          </div>
          {trip.commission === undefined && <span className="mt-1.5 block text-[11px] text-slate-400">Suggested at {settings.commissionRate}% of {fmtMoney(tripTotal(trip), true)} trip total</span>}
        </label>
        <dl className="space-y-2 text-sm">
          <div className="flex justify-between"><dt className="text-slate-500">Agent payout ({split}%)</dt><dd className="font-semibold text-navy-900" data-testid="commission-agent-amount">{fmtMoney(agent, true)}</dd></div>
        </dl>
      </div>
    </Card>
  );
}
